<div class="dialog-container">
    <div class="title">
        <h1>Recieve</h1>
    </div>
    <div class="content">
        <span class='address' (click)='copyAddress()'>{{ address }}</span>
        <span class='note'>(click over the address to copy in clipboard)</span>

        <div class="one-click" *ngIf="canOneClickDeposit">
            <h3>One-click BTC deposit (Phantom)</h3>
            <input
                matInput
                type="number"
                min="0"
                step="0.00000001"
                placeholder="Amount in BTC"
                [(ngModel)]="amount"
            />
            <button
                mat-raised-button
                color="primary"
                (click)="depositWithPhantom()"
                [disabled]="submitting"
            >
                {{ submitting ? 'Submitting...' : 'Deposit With Phantom' }}
            </button>
        </div>
    </div>
    <div class="buttons">
        <button mat-button (click)="close()" color="warn">CANCEL</button>
    </div>
</div>
